module.exports = __webpack_public_path__ + "static/media/mediawiki-logo.1080e72c.png";